/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Unknown_TypeInputs */

const en_api_error_task_unknown_type = /** @type {(inputs: Api_Error_Task_Unknown_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity does not exist.`)
};

const pt_br2_api_error_task_unknown_type = /** @type {(inputs: Api_Error_Task_Unknown_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade não existe.`)
};

/**
* | output |
* | --- |
* | "This activity does not exist." |
*
* @param {Api_Error_Task_Unknown_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_unknown_type = /** @type {((inputs?: Api_Error_Task_Unknown_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Unknown_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_unknown_type(inputs)
	return pt_br2_api_error_task_unknown_type(inputs)
});